import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import { ContextDataProvider } from './contextApi';
import PermissionBasedMenuProvider from "./contextApi/permissionBasedMenuContext";
import { ThemeProvider } from "styled-components";
// import { CookiesProvider } from 'react-cookie';
import "./theme/global.css";
import { theme } from "./theme/theme";
import GlobalStyles from "./theme/GlobalStyles.js";


ReactDOM.render(
  <>
    {/* <CookiesProvider> */}
    <ContextDataProvider>
      <PermissionBasedMenuProvider>
        <ThemeProvider theme={theme}>
          <GlobalStyles />
          <App />
        </ThemeProvider>,
      </PermissionBasedMenuProvider>
    </ContextDataProvider>
    {/* </CookiesProvider> */}
  </>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
